import React from "react";

const Reports = () => {
    return (
        <>
            <h1>Reports</h1>
        </>
    );
}

export { Reports };